// Display-only ISO-8601 week label. Weeks run Monday-Sunday; week 1 is the
// week containing January 4th. Backend keys weeks by their Monday date
// (weekStart) instead of (year, weekNumber), so this is purely presentational.
export function isoWeekLabel(dateStr: string): string {
  const d = new Date(dateStr + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7)); // move to this week's Thursday
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const week = Math.ceil((((d.getTime() - yearStart.getTime()) / 86_400_000) + 1) / 7);
  return `Week ${week} · ${d.getUTCFullYear()}`;
}

// Monday (UTC midnight, YYYY-MM-DD) of the most recently fully-completed week,
// given "today" in IST — used as the default week shown on first load.
export function lastCompletedMonday(): string {
  const now = new Date();
  const istNow = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
  const dow = istNow.getDay() || 7; // 1 (Mon) .. 7 (Sun)
  const thisMonday = new Date(Date.UTC(istNow.getFullYear(), istNow.getMonth(), istNow.getDate() - (dow - 1)));
  thisMonday.setUTCDate(thisMonday.getUTCDate() - 7);
  return thisMonday.toISOString().slice(0, 10);
}

export function shiftWeek(weekStart: string, deltaWeeks: number): string {
  const d = new Date(weekStart + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() + deltaWeeks * 7);
  return d.toISOString().slice(0, 10);
}

// A week belongs to the month its Thursday falls in, as ISO weeks do. Returns that
// month's first day (YYYY-MM-01), so a week that straddles two months is listed in one.
export function monthOfWeek(weekStart: string): string {
  const thursday = new Date(weekStart + "T00:00:00Z");
  thursday.setUTCDate(thursday.getUTCDate() + 3);
  return thursday.toISOString().slice(0, 7) + "-01";
}

// Monday of the first week that belongs to the month starting on monthStart (YYYY-MM-01).
export function firstWeekOfMonth(monthStart: string): string {
  // A Monday is in the month when it falls no earlier than three days before the 1st.
  const d = new Date(monthStart + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() - 3);
  d.setUTCDate(d.getUTCDate() + ((8 - (d.getUTCDay() || 7)) % 7));
  return d.toISOString().slice(0, 10);
}
